(() => {
  const section = document.querySelector('.main-product[data-product-section]');
  if (!section) return;

  const modelInputs = Array.from(section.querySelectorAll('[data-grill-model-input]'));
  if (!modelInputs.length) return;

  const subtitleNodes = Array.from(section.querySelectorAll('[data-kabo-product-subtitle]'));
  const subtitleSource = subtitleNodes[0];

  const subtitleForModel = (model) => {
    if (!subtitleSource) return '';
    return model === 'pro'
      ? (subtitleSource.dataset.kaboSubtitlePro || subtitleSource.dataset.kaboSubtitleDefault || '')
      : (subtitleSource.dataset.kaboSubtitleStandard || subtitleSource.dataset.kaboSubtitleDefault || '');
  };

  const syncSubtitle = () => {
    const checked = modelInputs.find((input) => input.checked);
    const model = checked?.value === 'pro' ? 'pro' : 'standard';
    const text = subtitleForModel(model);
    if (!text) return;
    subtitleNodes.forEach((subtitle) => {
      subtitle.textContent = text;
    });
  };

  modelInputs.forEach((input) => input.addEventListener('change', syncSubtitle));
  syncSubtitle();
})();
